import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Pnls/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class PnlsCommands extends VueCqrs {

	invokeDeletePnlCommandV1(workspaceId: number, strategyId: string, pnlId: string)
	{
		const cmd = new c.DeletePnlCommandV1(workspaceId, strategyId, pnlId);
		this.$command(cmd, pnlId);
	}

	invokeCreatePnlCommandV1(workspaceId: number, strategyId: string, pnlId: string, name: string, startYear: number, startMonth: number, columns: string)
	{
		const cmd = new c.CreatePnlCommandV1(workspaceId, strategyId, pnlId, name, startYear, startMonth, columns);
		this.$command(cmd, pnlId); 
	}

	invokeUpdatePnlCommandV1(workspaceId: number, strategyId: string, pnlId: string, name: string, startYear: number, startMonth: number, columns: string)
	{
		const cmd = new c.UpdatePnlCommandV1(workspaceId, strategyId, pnlId, name, startYear, startMonth, columns);
		this.$command(cmd, pnlId); 
	}
}
